import { render } from "./BaseRoomForm.vue?vue&type=template&id=764ee3c6&scoped=true"
import script from "./BaseRoomForm.vue?vue&type=script&lang=ts"
export * from "./BaseRoomForm.vue?vue&type=script&lang=ts"

import "./BaseRoomForm.vue?vue&type=style&index=0&id=764ee3c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-764ee3c6"

export default script